import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface ShareReportPayload {
  reportId: string;
  email: string;
}

interface ShareReportResponse {
  message: string;
  data: any;
}

/**
 * Hook for sharing a report via email using v2 endpoint
 */
export const useShareReport = () => {
  const { openToast } = useToast();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ reportId, email }: ShareReportPayload) => {
      const response = await apiClient.post(`/reports/${reportId}/share/`, { email });
      return response.data as ShareReportResponse;
    },
    onSuccess: (data) => {
      openToast({
        show: true,
        heading: "Success",
        text: data.message || "Report shared successfully",
        type: "success",
        timeOut: 5000,
      });
    },
    onError: (error: any) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to share report';
      openToast({
        show: true,
        heading: "Error",
        text: errorMessage,
        type: "error",
        timeOut: 5000,
      });
    },
  });

  return {
    shareReport: mutation.mutate,
    isSharing: mutation.isPending,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
  };
};
